import React, { useReducer } from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const initialState = {
  referenceElement: null,
  toggle: () => {
  },
  isOpen: false,
  toggleType: ""
};
const DropdownContext = React.createContext({ state: initialState });
const DropdownProvider = ({
  children,
  value
}) => {
  const [state, dispatch] = useReducer((state2 = initialState, action) => {
    switch (action.type) {
      case "SET_REFERENCE":
        return __spreadProps(__spreadValues({}, state2), {
          referenceElement: action.payload
        });
      default:
        return state2;
    }
  }, initialState);
  return /* @__PURE__ */ React.createElement(DropdownContext.Provider, {
    value: { state: __spreadValues(__spreadValues({}, state), value), dispatch }
  }, children);
};

export { DropdownContext, DropdownProvider };
